import { FC, HTMLProps } from 'react';

export const DevicesIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M9.75 15.5C9.33579 15.5 9 15.8358 9 16.25C9 16.6642 9.33579 17 9.75 17H12.25C12.6642 17 13 16.6642 13 16.25C13 15.8358 12.6642 15.5 12.25 15.5H9.75ZM8.25 2C7.00736 2 6 3.00736 6 4.25V17.25C6 18.4926 7.00736 19.5 8.25 19.5H13.75C14.9926 19.5 16 18.4926 16 17.25V4.25C16 3.00736 14.9926 2 13.75 2H8.25ZM7.5 4.25C7.5 3.83579 7.83579 3.5 8.25 3.5H13.75C14.1642 3.5 14.5 3.83579 14.5 4.25V17.25C14.5 17.6642 14.1642 18 13.75 18H8.25C7.83579 18 7.5 17.6642 7.5 17.25V4.25ZM10.7499 22C9.77024 22 8.93681 21.3739 8.62793 20.5H14.2499C15.7687 20.5 16.9999 19.2688 16.9999 17.75V4.62805C17.8738 4.93693 18.4999 5.77036 18.4999 6.75002V17.75C18.4999 20.0972 16.5971 22 14.2499 22H10.7499Z"
        fill="currentColor"
      />
    </svg>
  );
};
